import { PiAirplaneInFlight } from "react-icons/pi";
import StaticLayout from "../../layout/StaticPageLayout2";
import { FaArrowRightLong } from "react-icons/fa6";
import { BsCalendar2Event, BsDot } from "react-icons/bs";
import { Button } from "../../layout/component/Button";
import { ChangeEvent, useEffect, useState } from "react";
import { IoPeopleSharp } from "react-icons/io5";
import { GiMoneyStack } from "react-icons/gi";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store";
import { SelectFlight } from "../../store/slice/flight";
import { SelectUpdate } from "../../store/slice/update";
import { createBookings, searchOneFlight } from "../../store/service/flight";
import { findLocationFromIATA } from "../../utils/data";
import {
  convertMinutesToHoursAndMinutes,
  dateTime,
  isValidEmail,
  numberFormatter,
} from "../../utils/functions";
import toast from "react-hot-toast";
import { routeObj } from "../../constants/routes";
import { authConfig } from "../../utils/constants";

export default function Bookings() {
  // const [whatsapp, setWhatsapp] = useState(false);
  const { id } = useParams<{ id?: string }>();
  const { query, others } = useAppSelector(SelectUpdate);
  const { flight, loading: resLoading } = useAppSelector(SelectFlight);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [bookingInfo, setBookingsInfo] = useState<{
    email: string;
    first_name: string;
    last_name: string;
    phone: string;
    gender?: string;
    departure_id: string;
    arrival_id: string;
    departure_token: string;
  }>({
    arrival_id: query?.arrival_id,
    departure_id: query?.departure_id,
    departure_token: id!,
    email: "",
    phone: "",
    first_name: "",
    last_name: "",
    gender: "Male",
  });

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    console.log(event.target.name);
    setBookingsInfo((prev) => {
      return { ...prev, [event.target.name]: event.target.value };
    });
  };

  const getFlightDetails = async () => {
    try {
      await dispatch(
        searchOneFlight({
          id: id!,
          arrival_id: query?.arrival_id,
          departure_id: query?.departure_id,
          type: others?.trip === "ROUND_TRIP" ? 1 : 2,
        })
      ).unwrap();
    } catch (error) {
      navigate(routeObj.flight);
      toast.error("Invalid Flight Number");
    }
  };

  useEffect(() => {
    if (id) {
      getFlightDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <StaticLayout>
      <div className=" min-h-[300px] py-10 bg-main ">
        <p className=" w-[95%] md:w-[80%] mx-auto font-bold md:text-[20px] pb-8 text-white  ">
          Flight Summary
        </p>

        <div className=" w-[95%] md:w-[80%] mx-auto flex flex-col md:flex-row gap-10 md:items-center   text-white ">
          <div className=" w-full md:w-[50%] flex md:flex-col items-cente justify-between ">
            <div className=" w-full flex gap-2  min-h-[60px]  ">
              <div className=" px-3 flex justify-center items-center py-3 h-fit bg-slate-500/50 rounded-full ">
                <PiAirplaneInFlight className=" text-[18px] " />
              </div>
              <div className="">
                <p className="uppercase text-[11px]  ">Route</p>
                <p className=" font- flex items-center text-[14px] gap-2 ">
                  {findLocationFromIATA(query.departure_id)}{" "}
                  <FaArrowRightLong /> {findLocationFromIATA(query.arrival_id)}
                </p>
              </div>
            </div>

            <div className=" w-full flex gap-2 md:mt-5  min-h-[60px]  ">
              <div className=" px-3 flex justify-center items-center py-3 h-fit bg-slate-500/50 rounded-full ">
                <BsCalendar2Event className=" text-[18px] " />
              </div>
              <div className="">
                <p className="uppercase text-[11px]  ">Schedule</p>
                <p className=" font- flex items-center text-[14px] gap-2 ">
                  <p className="">
                    {" "}
                    {dateTime(flight?.flights[0].departure_airport?.time!)}
                  </p>{" "}
                  -
                  <p className="">
                    {" "}
                    {dateTime(flight?.flights[0].arrival_airport?.time!)}
                  </p>
                </p>
                <p className="uppercase text-[11px]  ">
                  Duration:{" "}
                  {convertMinutesToHoursAndMinutes(flight?.total_duration!)}
                </p>
              </div>
            </div>
          </div>
          <div className=" w-full md:w-[50%] flex md:flex-col items-cente justify-between ">
            <div className=" w-full flex gap-2  min-h-[60px]  ">
              <div className=" px-3 flex justify-center items-center py-3 h-fit bg-slate-500/50 rounded-full ">
                <IoPeopleSharp className=" text-[18px] " />
              </div>
              <div className="">
                <p className="uppercase text-[11px]  ">Passengers</p>
                <p className=" font- flex items-center text-[14px] gap-2 ">
                  {Number(others?.adults) + Number(others.children)} passenger
                </p>
              </div>
            </div>

            <div className=" w-full flex gap-2 md:mt-5  min-h-[60px]  ">
              <div className=" px-3 flex justify-center items-center py-3 h-fit bg-slate-500/50 rounded-full ">
                <GiMoneyStack className=" text-[18px] " />
              </div>
              <div className="">
                <p className="uppercase text-[11px]  ">Total Price</p>
                <p className=" font- flex items-center text-[14px] gap-2 ">
                  ₦{numberFormatter(flight?.price! * 10)}
                </p>
                {/* <p className="uppercase text-[11px]  ">$299 per passenger</p> */}
              </div>
            </div>
          </div>
        </div>

        <div className="w-[95%] md:w-[80%] border-t-[1px] mx-auto font-bold text-[20px] mt-5 text-white  ">
          <div className=" w-full justify-around md:justify-normal gap-1  flex-wrap md:gap-8 text-[10px] md:text-sm  flex my-3 ">
            <div className="flex items-center gap- ">
              <BsDot fontSize={"20px"} />
              <p className=""> {flight?.flights[0].extensions[0]}</p>
            </div>
            <div className="flex items-center gap- ">
              <BsDot fontSize={"20px"} />
              <p className="">Aircraft: {flight?.flights[0].airplane}</p>
            </div>
            <div className="flex items-center gap- ">
              <BsDot fontSize={"20px"} />
              <p className="">Amenities: Wi-Fi, Meals</p>
            </div>
          </div>
        </div>
      </div>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          if (isValidEmail(bookingInfo.email)) {
            localStorage.setItem(authConfig.usersEmail, bookingInfo.email);
            try {
              setLoading(true);
              const { data } = await dispatch(
                createBookings(bookingInfo)
              ).unwrap();
              window.location.href = data?.data?.link;
              return setLoading(false);
            } catch (error: any) {
              setLoading(false);
              return toast.error(error);
            }
          }
          toast.error("Invalid email address");
        }}
        className="w-[90%] md:w-[70%] bg-white shadow-lg mx-auto my-10 flex flex-col gap-5  border-[1px] px-8 py-8 rounded-xl "
      >
        <p className="  font-bold md:text-[20px] ">Passenger Information</p>
        <div className=" flex flex-col md:flex-row border-b-[1px pb-10 flex-wrap gap-5 justify-between ">
          <div className=" w-full md:w-[45%] flex flex-col gap-2 ">
            <p className=" text-sm ">First Name</p>
            <input
              onChange={onChange}
              name="first_name"
              type="text"
              required
              className=" py-2 w-full border-[1px] rounded-lg outline-none px-3 "
            />
          </div>
          <div className=" w-full md:w-[45%] flex flex-col gap-2 ">
            <p className=" text-sm ">Last Name</p>
            <input
              type="text"
              name="last_name"
              onChange={onChange}
              required
              className=" py-2 w-full border-[1px] rounded-lg outline-none px-3 "
            />
          </div>
          <div className=" w-full md:w-[45%] flex flex-col gap-2 ">
            <p className=" text-sm ">Email</p>
            <input
              onChange={onChange}
              name="email"
              type="text"
              required
              className=" py-2 w-full border-[1px] rounded-lg outline-none px-3 "
            />
          </div>
          <div className=" w-full md:w-[45%] flex flex-col gap-2 ">
            <p className=" text-sm ">Phone Number</p>
            <input
              onChange={onChange}
              name="phone"
              type="number"
              required
              className=" py-2 w-full border-[1px] rounded-lg outline-none px-3 "
            />
          </div>
        </div>
        {/* <label className="flex cursor-pointer gap-2 text-sm ">
          {" "}
          <input
            checked={whatsapp}
            type="checkbox"
            className=" accent-black  "
            name=""
            onChange={() => setWhatsapp(!whatsapp)}
            id=""
          />{" "}
          Want your booking via WhatsApp?
        </label>

        <div className=" flex pb-10 flex-wrap gap-5 justify-between ">
          <div className=" w-full flex flex-col gap-2 ">
            <p className=" text-sm ">Whatsapp Number</p>
            <input
              type="number"
              required={whatsapp}
              className=" py-2 w-full border-[1px] rounded-lg outline-none px-3 "
            />
          </div>
        </div> */}
        <div className=" flex justify-end w-full ">
          <Button
            loading={loading}
            type="submit"
            className=" bg-secondary w-full md:w-fit text-white px-5 py-3 font-bold "
          >
            Complete Booking
          </Button>
        </div>
      </form>
    </StaticLayout>
  );
}
